import survey from 'sanitas-survey-vue2/src/store/survey'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const modules = {
  survey,
}

export default new Vuex.Store({
  modules,
})
